// The save-time merge for task-level "Add course materials" (Create Task → Advanced).
//
// The card's attachments are re-applied onto EVERY question here so question
// add/delete/duplicate/reorder can never drop or double an attachment. Legacy picker
// point refs (refs WITH pointIds) are preserved untouched; whole-document refs are
// always rewritten from the card.
//
// The 'course-materials' feedback type is kept in step with the refs on both arrays:
// useAssignmentOperations prefers an explicit feedbackTypes/enabledFeedbackTypes list
// over inference, so leaving the type stale there would make the payload disagree with
// the refs it carries. Nothing server-side gates the prompt on the type today — the
// block renders from the refs — but the payload must not lie about itself.

const FEEDBACK_TYPE = 'course-materials';

const withType = (types, enabled) => {
  const rest = (types || []).filter((t) => t !== FEEDBACK_TYPE);
  return enabled ? [...rest, FEEDBACK_TYPE] : rest;
};

const pointRefsOf = (question) =>
  (question.courseMaterials || []).filter((ref) => (ref?.pointIds || []).length > 0);

export const mergeTaskCourseMaterialsIntoQuestions = (questions, taskMaterials) => {
  const taskRefs = (taskMaterials || []).map((m) => ({ materialId: m.id, pointIds: [] }));
  return (questions || []).map((question) => {
    const courseMaterials = [...pointRefsOf(question), ...taskRefs];
    const merged = { ...question, courseMaterials };
    const hasRefs = courseMaterials.length > 0;
    // Only adjust arrays the question explicitly carries — when neither exists,
    // useAssignmentOperations infers the list from the refs, which is already right.
    if (Array.isArray(question.feedbackTypes)) {
      merged.feedbackTypes = withType(question.feedbackTypes, hasRefs);
    }
    if (Array.isArray(question.enabledFeedbackTypes)) {
      merged.enabledFeedbackTypes = withType(question.enabledFeedbackTypes, hasRefs);
    }
    return merged;
  });
};

export default mergeTaskCourseMaterialsIntoQuestions;
